<template>
  <div class="home">
    <HeaderLandingNew :custom-class="'z-index-2'" />
    <HeaderLandingContent />
    <div class="container-section ">
      <div class="content-section-2">
        <b-container fluid class="mt-5 mb-5" style="min-height: 65vh;" >
          <b-row align-h="center" v-if="!registerSuccess">
            <b-col cols="12" md="4">
              <b-form @submit.event.prevent="register" class="d-flex flex-column align-items-center">
                <b-nav pills class="mb-5 justify-content-center nav-signin" >
                  <b-nav-item active >Sign Up</b-nav-item>
                  <b-nav-item href="/#/login" >Log In</b-nav-item>
                </b-nav>
                <template v-if="showFormEmail">
                  <div class="w-100 d-flex justify-content-start align-items-center" style="margin-bottom: 32px">
                    <a @click="showFormEmail = false;$v.form.$reset()" class="cursor-pointer text-decoration-none" style="color: #4d4d4d">
                      <font-awesome-icon :icon="['fas', 'arrow-left']" class="icon-back" style="margin-right:20px" />
                      <span style="font-size: 20px;line-height: 24px;">Back</span>
                    </a>
                  </div>
                  <h4 class="font-weight-bolder mb-4">Sign Up with Email</h4>
                  <b-form-group id="input-group-firstname" class="mb-4 w-100">
                    <b-form-input
                      id="input-firstname"
                      v-model="$v.form.first_name.$model"
                      :state="validateState('first_name')"
                      type="text"
                      placeholder="Enter First Name"
                      aria-describedby="input-firstname-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-firstname-feedback"
                      class="text-left"
                    >This is a required field.</b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group id="input-group-lastname" class="mb-4 w-100">
                    <b-form-input
                      id="input-lastname"
                      v-model="$v.form.last_name.$model"
                      :state="validateState('last_name')"
                      type="text"
                      placeholder="Enter Last Name"
                      aria-describedby="input-lastname-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-lastname-feedback"
                      class="text-left"
                    >This is a required field.</b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group id="input-group-email" class="mb-4 w-100">
                    <b-form-input
                      id="input-email"
                      v-model="$v.form.email.$model"
                      :state="validateState('email')"
                      type="email"
                      placeholder="Enter email"
                      aria-describedby="input-email-feedback"
                      :disabled="isSocial"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-email-feedback"
                      class="text-left"
                    >This is a required field and must be a valid email.</b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group id="input-group-country" class="mb-4 w-100">
                    <b-form-select
                      id="input-country"
                      v-model="$v.form.country.$model"
                      :options="listCountry"
                      :state="validateState('country')"
                      aria-describedby="input-country-feedback"
                      @change="selectCountry"
                    ></b-form-select>
                    <b-form-invalid-feedback
                      id="input-country-feedback"
                      class="text-left"
                    >This is a required field.</b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group v-if="!!form.country" id="input-group-phone" class="position-relative mb-4 w-100">
                    <div class="position-absolute phone-country">
                      {{phone_country}}
                    </div>
                    <b-form-input
                      id="input-phone"
                      v-model="$v.form.phone_number.$model"
                      :state="validateState('phone_number')"
                      type="text"
                      placeholder="Enter Phone Number"
                      aria-describedby="input-phone-feedback"
                      style="padding-left: 54px"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-phone-feedback"
                      class="text-left"
                    >must be a numeric character.</b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group id="input-group-gender" class="mb-4 w-100">
                    <b-form-select
                      id="input-gender"
                      v-model="form.gender"
                      :options="listGender"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group v-if="!isSocial" id="input-group-password" class="mb-4 position-relative w-100">
                    <b-form-input
                      :type="showPassword?'text':'password'"
                      id="input-password"
                      v-model="$v.form.password.$model"
                      placeholder="Enter Password"
                      :state="validateState('password')"
                      aria-describedby="input-password-feedback"
                    ></b-form-input>
                    <a class="position-absolute show-hide-password" @click="showPassword=!showPassword">
                      <font-awesome-icon class="text-dark" :icon="['fa', showPassword?'eye-slash':'eye']" />
                    </a>
                    <b-form-invalid-feedback
                      id="input-password-feedback"
                      class="text-left"
                    >This is a required field and have a minimum 6 characters.</b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group v-if="!isSocial" id="input-group-confirmpassword" class="mb-4 position-relative w-100">
                    <b-form-input
                      :type="showConfirmPassword?'text':'password'"
                      id="input-confirmpassword"
                      v-model="$v.form.confirm_password.$model"
                      placeholder="Enter Confirm Password"
                      :state="validateState('confirm_password')"
                      aria-describedby="input-confirmpassword-feedback"
                    ></b-form-input>
                    <a class="position-absolute show-hide-password" @click="showConfirmPassword=!showConfirmPassword">
                      <font-awesome-icon class="text-dark" :icon="['fa', showConfirmPassword?'eye-slash':'eye']" />
                    </a>
                    <b-form-invalid-feedback
                      id="input-confirmpassword-feedback"
                      class="text-left"
                    >This is a required field and must match the password field.</b-form-invalid-feedback>
                  </b-form-group>
                  <b-button type="submit" variant="primary" class="btn-block">Sign Up</b-button>
                </template>
                <template v-else>
                  <h4 class="font-weight-bolder mb-4">Registration</h4>
                  <b-button type="button" variant="default" class="btn-block btn-social" @click="signUpFB">
                    <img src="@/assets/fb-icon.svg" alt="logo"/>
                    Sign Up with Facebook
                  </b-button>
                  <b-button type="button" variant="default" class="btn-block btn-social" @click="signUpGoogle">
                    <img src="@/assets/google-icon.svg" alt="logo"/>
                    Sign Up with Google
                  </b-button>
                  <b-button type="button" variant="default" class="btn-block btn-social" @click="signUpApple">
                    <img src="@/assets/apple-icon.svg" alt="logo"/>
                    Sign Up with Apple
                  </b-button>
                  <b-button type="button" variant="default" class="btn-block btn-social" @click="toggleFormEmail">
                    <img src="@/assets/mail-icon.svg" alt="logo"/>
                    Sign Up with Email
                  </b-button>
                  <span class="d-flex justify-content-center" style="margin-top: 56px;margin-bottom: 23px;font-size: 16px;line-height: 19px;">Already have account?</span>
                  <b-button type="button" variant="primary"  @click="goToLogin">
                    Login
                  </b-button>
                </template>

                <div class="border-bottom border-dark mb-3" style="margin-top:89px"></div>
                <p class="text-center">Download MusicVerse. Your one-stop app for sacred music</p>
                <b-row class="justify-content-center align-items-center flex-column flex-sm-row">
                  <a :href="appStoreUrl" class="mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo" aria-label="App Store" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/applestore-logo.png" class="content-logo" alt="App Store">
                  </a>
                  <a :href="googlePlayUrl" class="mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo" aria-label="Google Play" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/googleplay-logo.png" class="content-logo" alt="Google Play">
                  </a>
                  <a :href="appGalleryUrl" class="mt-3 mt-xl-0 content-logo radius" aria-label="App Gallery" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/huawei-logo.png" class="content-logo radius" alt="App Gallery">
                  </a>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
          <b-row align-h="center" v-if="registerSuccess" style="margin-bottom: 40px; text-align: center">
            <b-col cols="12" md="6">
              <h2 class="font-weight-bolder mb-5">Thank You for Registering at MusicVerse!</h2>
              <p>
                We have sent an email with a confirmation link to the email address you registered. Please click the link to complete the registration process.
              </p>
              <p>
                If the email is not found in your email inbox, please check your spam folder.
              </p>
              <p>
                If email is not received at all, click here to <a class="cursor-pointer" @click="resend">resend</a> to {{form.email}}.
              </p>
              <a href="/#/login" class="btn btn-primary w-50 mt-3">Go to Login</a>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <FooterLandingNew />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate';
import helperMixins from '../mixins/helpers.mixins';
import { required, minLength, email, sameAs, numeric } from 'vuelidate/lib/validators';
import HeaderLanding from '../components/HeaderLanding';
import FooterLanding from '../components/FooterLanding';
import HeaderLandingNew from '@/components/HeaderLandingNew';
import FooterLandingNew from '@/components/FooterLandingNew';
import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
  signOut, updateProfile,
} from 'firebase/auth';
import HeaderLandingContent from '@/components/HeaderLandingContent.vue';

const MV_URL = process.env.MUSICVERSE_URL;
export default {
  name: 'Registration',
  mixins: [validationMixin, helperMixins],
  data: () => ({
    isLoading: false,
    mv_url: MV_URL,
    appStoreUrl: process.env.VUE_APP_ALL_BUTTON_LINK_IOS || 'https://musicverse.onelink.me/vYmO/mainwebsite',
    googlePlayUrl: process.env.VUE_APP_ALL_BUTTON_LINK_ANDROID || 'https://musicverse.onelink.me/vYmO/mainwebsite',
    appGalleryUrl: 'https://appgallery.huawei.com/#/app/C104486453',
    showPassword: false,
    showConfirmPassword: false,
    form: {
      first_name: '',
      last_name: '',
      email: '',
      country: null,
      password: '',
      confirm_password: '',
      uid: '',
      token: '',
      method: 'email',
      gender: null,
      phone_number: '',
    },
    listCountryRaw: [],
    listCountry: [],
    listGender: [],
    registerSuccess: false,
    showFormEmail: false,
    isSocial: false,
    phone_country: '',
  }),
  validations() {
    const rules = {
      form: {
        first_name: {
          required,
        },
        last_name: {
          required,
        },
        email: {
          required, email,
        },
        country: {
          required,
        },
      },
    };
    if (!this.isSocial) {
      rules.form = { ...rules.form,
        password: {
          required,
          minLength: minLength(6),
        },
        confirm_password: {
          required,
          minLength: minLength(6),
          sameAsPassword: sameAs('password'),
        } };
    }
    if (this.form.country) {
      rules.form = {
        ...rules.form,
        phone_number: {
          numeric,
        },
      };
    }

    return rules;
  },
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode', 'getNextPage']),
    ...mapGetters('AuthModule', ['getUser', 'getUserSocial']),
  },
  async mounted() {
    const genders = ['Male', 'Female'];
    let countries = await this.requestCountry();
    this.listCountryRaw = Object.assign([], countries);
    countries = countries.map(c => ({
      value: c.code,
      text: c.name,
    }));
    this.listGender = genders.map(g => ({
      value: g,
      text: g,
    }));
    const listGenders = this.listGender;
    this.listGender = [
      {
        value: null,
        text: 'None',
      },
      ...listGenders,
    ];
    this.listCountry = [
      {
        value: null,
        text: 'Choose Country',
      },
      ...countries,
    ];
    if (this.getUserSocial.token !== '') {
      this.isSocial = true;
      this.form = {
        first_name: this.getFirstName(this.getUserSocial.name),
        last_name: this.getLastName(this.getUserSocial.name),
        email: this.getUserSocial.email,
        country: null,
        password: '',
        confirm_password: '',
        uid: this.getUserSocial.uid,
        token: this.getUserSocial.token,
        method: this.getUserSocial.method,
        gender: null,
        phone_number: '',
      };
      this.showFormEmail = true;
    }
  },
  methods: {
    ...mapActions('AuthModule', ['requestRegister', 'requestResendVerify', 'requestCountry',
      'setUserSocial', 'removeUserSocial', 'requestAuthenticationSocial', 'requestSetAuth']),
    ...mapActions('NotificationModule', ['setNextPage']),
    redirectAfter() {
      if (this.getNextPage !== '') {
        const nextPageUrl = this.getNextPage;
        const [nextPage, paramsPage] = nextPageUrl.split('?');
        let params = {};
        if (paramsPage) {
          params = JSON.parse(`{"${paramsPage.replace(/&/g, '","').replace(/=/g, '":"')}"}`, (key, value) => (key === '' ? value : decodeURIComponent(value)));
        }
        this.setNextPage('');
        this.$router.push({ name: nextPage, query: params });
      } else {
        this.$router.push({ name: 'Dashboard' });
      }
    },
    selectCountry(e) {
      const filtered = this.listCountryRaw.filter(c => c.code === e);
      this.phone_country = filtered[0].phone_code;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async register() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let user = {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        email: this.form.email,
        password: this.form.password,
        country_code: this.form.country,
        gender: this.form.gender,
        phone_number: this.form.phone_number,
        method: this.form.method,
      };
      if (this.isSocial) {
        user = { ...user,
          token: this.form.token,
          uid: this.form.uid,
          password: '-',
        };
      }
      const response = await this.requestRegister(user);
      if (!response.error) {
        if (this.isSocial) {
          await this.requestSetAuth(response.data);
          this.removeUserSocial();
          this.redirectAfter();
        } else {
          this.registerSuccess = true;
        }
      } else {
        Vue.swal('Error', response.msg, 'error');
      }
    },
    async resend() {
      const email = this.form.email;
      const res = await this.requestResendVerify(email);
      if (res) {
        Vue.swal('Resend Email Sent', '', 'success');
      } else {
        Vue.swal('Error', 'Something Wrong. Please Try Again', 'error');
      }
    },
    toggleFormEmail() {
      this.showFormEmail = !this.showFormEmail;
      if (this.showFormEmail) {
        this.removeUserSocial();
        this.isSocial = false;
        this.form = {
          first_name: '',
          last_name: '',
          email: '',
          country: null,
          password: '',
          confirm_password: '',
          uid: '',
          token: '',
          method: 'email',
          gender: null,
          phone_number: '',
        };
      }
    },
    async signUpGoogle() {
      const provider = new GoogleAuthProvider();
      provider.addScope('email,profile');
      const auth = getAuth();
      await signOut(auth);
      signInWithPopup(auth, provider)
        .then(async (result) => {
          const user = result.user;
          this.setUserSocial({
            email: user.providerData[0].email,
            name: user.providerData[0].displayName,
            uid: user.providerData[0].uid,
            token: user.accessToken,
            method: 'google',
          });
          await this.signUpSocial('google', {
            email: user.providerData[0].email,
            name: user.providerData[0].displayName,
            uid: user.providerData[0].uid,
            token: user.accessToken,
          });
        }).catch((error) => {
          console.log(error);
        });
    },
    async signUpFB() {
      const provider = new FacebookAuthProvider();
      provider.addScope('email,public_profile');
      const auth = getAuth();
      await signOut(auth);
      signInWithPopup(auth, provider)
        .then(async (result) => {
          const user = result.user;
          this.setUserSocial({
            email: user.providerData[0].email,
            name: user.providerData[0].displayName,
            uid: user.providerData[0].uid,
            token: user.accessToken,
            method: 'facebook',
          });
          await this.signUpSocial('facebook', {
            email: user.providerData[0].email,
            name: user.providerData[0].displayName,
            uid: user.providerData[0].uid,
            token: user.accessToken,
          });
        }).catch((error) => {
          console.log(error);
        });
    },
    async signUpApple() {
      const provider = new OAuthProvider('apple.com');
      provider.addScope('email');
      provider.addScope('name');
      const auth = getAuth();
      await signOut(auth);
      signInWithPopup(auth, provider)
        .then(async (result) => {
          if (auth.currentUser.displayName === null && !!auth.currentUser.providerData[0].displayName) {
            await updateProfile(auth.currentUser, {
              displayName: auth.currentUser.providerData[0].displayName,
            });
          }
          const user = result.user;
          // console.log(user,'log user auth current user apple');
          // console.log(auth.currentUser,'log user auth current user firebase');
          const credential = OAuthProvider.credentialFromResult(result);
          this.setUserSocial({
            email: user.providerData[0].email,
            name: auth.currentUser.providerData[0].displayName ? auth.currentUser.providerData[0].displayName : '',
            uid: user.providerData[0].uid,
            token: user.accessToken,
            method: 'apple',
          });
          await this.signUpSocial('apple', {
            email: user.providerData[0].email,
            name: auth.currentUser.providerData[0].displayName ? auth.currentUser.providerData[0].displayName : '',
            uid: user.providerData[0].uid,
            token: user.accessToken,
          });
        }).catch((error) => {
          console.log(error);
        });
    },
    async signUpSocial(method, data) {
      const response = await this.requestAuthenticationSocial({ ...data, method });
      if (response) {
        if (response.data) {
          this.removeUserSocial();
          this.redirectAfter();
        } else {
          this.isSocial = true;
          this.form = {
            first_name: this.getFirstName(data.name),
            last_name: this.getLastName(data.name),
            email: data.email,
            country: null,
            password: '',
            confirm_password: '',
            token: data.token,
            uid: data.uid,
            gender: null,
            phone_number: '',
            method,
          };
          this.showFormEmail = true;
        }
      } else if (this.getStatus !== 200 && this.getErrorCode === 'ER-AUTH-01') {

      }
    },
    goToLogin() {
      this.$router.push({ name: 'Signin' });
    },
    getFirstName(name) {
      return name.split(' ')[0];
    },
    getLastName(name) {
      let lastName = '';
      const nameArray = name.split(' ');
      if (nameArray.length > 1) {
        nameArray.shift();
        for (let i = 0; i < nameArray.length; i++) {
          lastName += `${nameArray[i]} `;
        }
        return lastName;
      }
      return name;
    },
  },
  components: {
    HeaderLandingContent,
    HeaderLanding, FooterLanding,
    HeaderLandingNew, FooterLandingNew,
  },
};
</script>

<style>
  @import '../assets/stylesheets/landing.css';
  .section-register{
    background: url("~@/assets/bg-landing.png");
  }
  .section-register .so-content p{
    width: 730px;
  }
  .show-hide-password{
    cursor: pointer;
    top: 0px;
    right: 0px;
    display: flex;
    height: 32px;
    width: 28px;
    margin-right: 2px;
    margin-top: 2px;
    background: #fff;
    flex-direction: column;
    justify-content: center;
  }
  .btn-social{
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    border-radius: 999px;
    margin-bottom: 24px;
    padding:20px 0;
    font-size: 20px;
    line-height: 24px;
    color: #4D4D4D;
  }
  .btn-social img{
    width: 40.96px;
    margin-right: 20.39px;
  }
  .phone-country{
    left: 0;
    top: 0;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Registration.vue